import type { Room } from '../app/types';

interface RoomSelectorProps {
  rooms: Room[];
  selectedRoomId: string;
  viewMode: 'grid' | 'list';
  onSelect: (roomId: string) => void;
  onViewModeChange: (viewMode: 'grid' | 'list') => void;
}

export function RoomSelector({
  rooms,
  selectedRoomId,
  viewMode,
  onSelect,
  onViewModeChange
}: RoomSelectorProps) {
  return (
    <aside className="room-selector" aria-label="教室选择">
      <div className="panel-title-row">
        <h2>教室 <small>{rooms.length}间</small></h2>
        <div className="view-switch" role="radiogroup" aria-label="教室显示方式" data-view-mode={viewMode}>
          <button type="button" role="radio" aria-label="列表显示" aria-checked={viewMode === 'list'} onClick={() => onViewModeChange('list')}>列表</button>
          <button type="button" role="radio" aria-label="宫格显示" aria-checked={viewMode === 'grid'} onClick={() => onViewModeChange('grid')}>宫格</button>
        </div>
      </div>
      <div className={`room-list room-list--${viewMode}`}>
        {rooms.map((room) => (
          <button
            key={room.id}
            type="button"
            className={`room-card room-card--${room.status} ${selectedRoomId === room.id ? 'is-selected' : ''}`}
            aria-label={room.name}
            aria-pressed={selectedRoomId === room.id}
            onClick={() => onSelect(room.id)}
          >
            <strong>{room.name}</strong>
            <span className="room-card__title">{room.summaryTitle}</span>
            <span className="room-card__meta">{room.summaryMeta}</span>
            <em>{room.status === 'current' ? '上课中' : room.status === 'future' ? '等待上课' : '空闲中'}</em>
          </button>
        ))}
      </div>
    </aside>
  );
}
